import { render, staticRenderFns } from "./SpaceCard.vue?vue&type=template&id=01af442a"
import script from "./SpaceCard.vue?vue&type=script&lang=ts"
export * from "./SpaceCard.vue?vue&type=script&lang=ts"
import style0 from "./SpaceCard.vue?vue&type=style&index=0&id=01af442a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports